// extracted by mini-css-extract-plugin
export default {"iconContainer":"FloatingIcon_iconContainer__EG4U3","float":"FloatingIcon_float__m5pfu"};